<div class="p-md-5 p-3 lh-1" id="about">
  <h2 class="text-uppercase mb-5">(About us)</h2>

  <p class="neon-text" *ngIf="screenWidth > 1000; else responsive">
    Our mission<br>
    <span appAutoFitText style="position: absolute; left: 100px;">is to build a
      <span style="position: relative; bottom: 20px;">____</span>
      bridge<br>between art <span style="font-family: 'Arial';">&</span> technology</span>
  </p>

  <ng-template #responsive>
    <p class="neon-text">
      Our mission<br>
      <span appAutoFitText class="neon-end">is to build<br>
        a bridge<br><br> <span style="position: relative; right: 22vw">between<br></span> art &nbsp;&nbsp;&nbsp;&nbsp;<span style="font-family: 'Arial';">&</span><br>
        tech</span>
    </p>
  </ng-template>


  <div class="counters">
    <div class="d-flex justify-content-start">
      <div class="d-flex flex-column justify-content-center text-start">
        <p>08</p>
        <p>Talented artists</p>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <div class="d-flex flex-column justify-content-center text-start">
        <p>10</p>
        <p>Stunning artwork</p>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <div class="d-flex flex-column justify-content-center text-start">
        <p style="font-family: 'Arial'">&commat;#</p>
        <p>Where<span style="font-family: 'Arial'">?</span> We are worldwide</p>
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <div class="d-flex flex-column justify-content-center text-start">
        <p>250</p>
        <p>M² exhibition area</p>
      </div>
    </div>

  </div>
</div>